import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const MyProfile = Loadable(lazy(() => import("./MyProfile.jsx")));

const MyProfileRoutes = [
    { path: "/my-profile", element: <MyProfile/> },
];

export default MyProfileRoutes;